import { Fragment } from "react";
import HeaderCartButton from "./HeaderCartButton";
import cryptoImage from "../../assets/crypto.jpg";
import classes from "./Header.module.css";

// npm install react-icons
import { FaEthereum, FaBitcoin } from "react-icons/fa";

// Header wordt aangeroepen vanuit App
const Header = (props) => {
  return (
    <Fragment>
      <header className={classes.header}>
        <h1>
          <FaBitcoin /> Crypto <FaEthereum />
        </h1>
        <HeaderCartButton onClick={props.onShowCart} />
      </header>
      <div className={classes["main-image"]}>
        <img src={cryptoImage} alt="Crypto" />
      </div>
    </Fragment>
  );
};

export default Header;